import Image from 'next/image';
import ImgAuto from './img/auto.png';
import { IconTrash, IconChevronDown } from '@koleso-icons';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '@redux/hooks';
import { fetchUserAutoList, getIsLoadedListAuto, getUserAutoList, fetchDeleteUserAuto } from '@entities/Auto';
import { WrapperList } from '@app/shared/ui/WrapperList';
import { Button, ButtonSize, ButtonThemes, SkeletonLoading } from '@app/shared';
import { TitleList } from '@app/shared/ui/WrapperList/TitleList';
import { EmptyListStub } from '@app/shared/ui/EmptyListStub';
import { autoType } from '@app/entities/Auto/module/types/autoUserSchema';
import { ModalWindow } from '@app/shared/ui/ModalWindow';
import { useWindowSizing } from '@app/hooks/useSizeWindow';

import styles from './ListAutoUser.module.scss';

export const ListAutoUser = ({ title }) => {
  const [active, setActive] = useState<boolean>(false);
  const [autoRnToDelete, setAutoRnToDelete] = useState<number | null>(null);
  const isMobile = useWindowSizing(340);
  const dispatch = useAppDispatch();
  const list = useAppSelector(getUserAutoList);
  const isLoaded = useAppSelector(getIsLoadedListAuto);

  useEffect(() => {
    if (!isLoaded && !list?.length) {
      dispatch(fetchUserAutoList());
    }
  }, [isLoaded, list, dispatch]);

  const handlerDeleteAuto = async (autoRn: number) => {
    await dispatch(fetchDeleteUserAuto({ autoRn })).unwrap();
    setActive(false);
  };

  if (!isLoaded) {
    return <ListAutoUser.Skeleton />;
  }

  if (isLoaded && !list.length) {
    return (
      <>
        <TitleList title={title} />
        <EmptyListStub
          title="Пока нет информации."
          text="Данные по автомобилю появятся в Личном кабинете после визита в центр Колесо.ру"
          textBtn="Центры в моём городе"
          idTextBtn="btn-auto-shops"
          href="/shops"
          img={<Image src={ImgAuto} alt={'Пока нет информации.'} />}
        />
      </>
    );
  }

  return (
    <>
      <TitleList title={title} />
      <div className={styles.Wrapper}>
        {list.map(item => (
          <ListAutoUser.ItemAuto key={item.autoRn} {...item} setActive={setActive} setAutoRnToDelete={setAutoRnToDelete} />
        ))}
      </div>
      {active && (
        <ModalWindow
          className={styles.Modal}
          active={active}
          setActive={setActive}
          value={`${isMobile ? '' : 'Хотите'} ${isMobile ? 'У' : 'у'}далить автомобиль?`}
          buttonTextTwo="Удалить авто"
          buttonTextOne="Отмена"
          idTextBtnTwo="btn-auto-del"
          btnAction={() => handlerDeleteAuto(autoRnToDelete)}
        />
      )}
    </>
  );
};

ListAutoUser.ItemAuto = function ItemAuto({ carMark, gtd, autoRn, setActive, setAutoRnToDelete }: autoType) {
  const [open, setOpen] = useState<boolean>(false);
  const isMobile = useWindowSizing(600);
  const handleDeleteClick = () => {
    setActive(true);
    setAutoRnToDelete(autoRn);
  };

  return (
    <WrapperList className={styles.WrapperAuto}>
      <div className={styles.WrapperItemAuto}>
        <div className={styles.Mark}>
          {carMark} {isMobile && <IconChevronDown className={open ? styles.Down : ''} height={24} width={24} onClick={() => setOpen(!open)} />}
        </div>
        <div>
          <span>Гос.номер:</span> {gtd}
        </div>
        <div className={styles.Remove}>
          {!isMobile && <IconTrash width={16} height={16} onClick={handleDeleteClick} />}
          {isMobile && open && (
            <Button size={ButtonSize.S} themes={ButtonThemes.DarkViolet} onClick={handleDeleteClick} className={styles.RemoveAuto}>
              Удалить авто
            </Button>
          )}
        </div>
      </div>
    </WrapperList>
  );
};

ListAutoUser.Skeleton = function Skeleton() {
  return (
    <div className={styles.Wrapper}>
      <SkeletonLoading width={'100%'} height={'141px'} />
      <SkeletonLoading width={'100%'} height={'141px'} />
    </div>
  );
};
